import gql from 'graphql-tag';

const CAMPAIGN_ORDER_SESSION_DETAILS = gql`
  query CampaignOrderSessionDetails($where: CampaignOrderSessionsWithEventsWhereUniqueInput!) {
    campaignOrderSessionsWithEvents(where: $where) {
      key
      sessionId
      impressions {
        eventId
        media
        impressionTime
        impressionPublisherPlatform
        impressionPublisherUrl
        impressionPublisher
        impressionPublisherMedia
        impressionPubliserViewed
      }
      sessionJourney {
        dateTime
        event
        url
      }
    }
  }
`;

export default CAMPAIGN_ORDER_SESSION_DETAILS;
